import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId = '',
    security = {
        o: 'allow',
        t: 'allow',
        p: 'allow',
        u: 'deny',
    },
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.setMyOrgSecurity, {
        orgId,
        security,
    }, options);
    if (error) return { error, status };
    return content || {};
};
